import { render, staticRenderFns } from "./AnswerTextInput.vue?vue&type=template&id=5571fa30&scoped=true"
import script from "./AnswerTextInput.vue?vue&type=script&lang=js"
export * from "./AnswerTextInput.vue?vue&type=script&lang=js"
import style0 from "./AnswerTextInput.vue?vue&type=style&index=0&id=5571fa30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5571fa30",
  null
  
)

export default component.exports